'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$() {
}
export { $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ as $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ };
$p = $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$() {
}
export { $h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ as $h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ };
$h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$.prototype = $p;
var $d_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$, "presto.TwoFactorAuthView$DeleteTwoFactorAuth$", ({
  TO: 1
}));
export { $d_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ as $d_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ };
var $n_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$;
function $m_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$() {
  if ((!$n_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$)) {
    $n_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ = new $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$();
  }
  return $n_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$;
}
export { $m_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ as $m_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$ };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Delete-Two-Factor-Auth$.js.map
